
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Cross'
})
export default class Cross extends Vue {}
